<app-auth-modal-content [nextURL]="nextURL" [activeModal]="activeModal" [description]="description">
</app-auth-modal-content>
